"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowEthereumConnectionError = exports.EthereumProvider = exports.EthereumProviderErrorName = exports.EthereumNetwork = void 0;
var detect_provider_1 = __importDefault(require("@metamask/detect-provider"));
var ethers_1 = require("ethers");
var storage_1 = require("./storage");
var EthereumNetwork;
(function (EthereumNetwork) {
    EthereumNetwork[EthereumNetwork["MAINNET"] = 1] = "MAINNET";
    EthereumNetwork[EthereumNetwork["RINKEBY"] = 4] = "RINKEBY";
})(EthereumNetwork = exports.EthereumNetwork || (exports.EthereumNetwork = {}));
var EthereumProviderErrorName;
(function (EthereumProviderErrorName) {
    EthereumProviderErrorName["EthereumProviderMultipleChains"] = "EthereumProviderMultipleChains";
    EthereumProviderErrorName["WindowEthereumConnectionError"] = "WindowEthereumConnectionError";
})(EthereumProviderErrorName = exports.EthereumProviderErrorName || (exports.EthereumProviderErrorName = {}));
var JWTServer = "https://auth.manifoldxyz.dev";
var OAuthServer = "https://oauth2.manifoldxyz.dev";
var EthereumProviderMultipleChains = /** @class */ (function (_super) {
    __extends(EthereumProviderMultipleChains, _super);
    function EthereumProviderMultipleChains(message) {
        if (message === void 0) { message = undefined; }
        var _this = _super.call(this, message) || this;
        _this.name = EthereumProviderErrorName.EthereumProviderMultipleChains;
        return _this;
    }
    return EthereumProviderMultipleChains;
}(Error));
var WindowEthereumConnectionError = /** @class */ (function (_super) {
    __extends(WindowEthereumConnectionError, _super);
    function WindowEthereumConnectionError(message) {
        if (message === void 0) { message = undefined; }
        var _this = _super.call(this, message) || this;
        _this.name = EthereumProviderErrorName.WindowEthereumConnectionError;
        return _this;
    }
    return WindowEthereumConnectionError;
}(Error));
exports.WindowEthereumConnectionError = WindowEthereumConnectionError;
/**
 * @dev EthereumProvider is a singleton that allows all apps to interact with the ethereum chain
 *
 * ALL COMPONENTS MUST USE THE SAME NETWORK!!!
 *
 * Every application/component that wishes to call web3 functions or access the wallet should
 * first subscribe to the ADDRESS_CHANGED and PROVIDER_CHANGED events, then call initialize.
 *
 * Every application/component MUST call initialize first.
 *
 * When you wish to perform any write operations, the application/component must call connect. This
 * will either result in an ADDRESS_CHANGED (and optionally PROVIDER_CHANGED) on success, OR it will
 * throw an EthereumProviderNotConnected failure (if metamask is not installed, if the network is defined without a
 * fallbackProvider and the wallet network is on the wrong chain, or if the user rejects the connection request.)
 *
 * After calling initialize, you will have a provider to the correct network (and usage of web3 to the right network).
 * However, this does NOT mean that the installed wallet is on the right network.  To check that, use the
 * chainIsCorrect function.
 *
 * CATCHING ERRORS
 * ---------------
 * If you are trying to catch an error thrown by the EthereumProvider, you must NOT use instanceof, because
 * class bindings are lost during compilation. To see if a specific error type is thrown, use error name comparison
 * against the EthereumProviderErrorName enum values.  e.g.
 *   try {
 *     ...
 *   } catch (e) {
 *     if (e.name == EthereumProviderErrorName.WindowEthereumConnectionError) {
 *       // Do something
 *     } else {
 *       throw e
 *     }
 *   }
 *
 */
var _EthereumProvider = /** @class */ (function () {
    function _EthereumProvider() {
    }
    // Authentication configuration
    /**
     * Every class that uses EthereumProvider should call initialize
     *
     * If you pass in network and fallbackWebsockethost, we assume that the fallbackWebsocketHost is
     * on the same network as the one desired
     *
     * @param network               - The network you wish to run on.  If false, there is no preference
     * @param fallbackWebsockethost - The fallbackWebsocketHost for a provider (useful for browsers with no metamask)
     * @param signingProviderr      - Initialize with a signing provider. Network must match the network parameter
     */
    _EthereumProvider.initialize = function (network, fallbackWebsockethost, signingProvider) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // Configure network
                        if (network) {
                            // Even though we type network, someone might accidentally pass in a string
                            network = parseInt(network.toString());
                            if (isNaN(network))
                                throw new Error("Invalid network provided");
                        }
                        // If network was already set, all networks must be the same
                        if (this._network && this._network != network)
                            throw new EthereumProviderMultipleChains("Only one chain can be used at a time.");
                        this._network = network;
                        if (!signingProvider) return [3 /*break*/, 3];
                        _a = !network;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, signingProvider.getNetwork()];
                    case 1:
                        _a = (_b.sent()).chainId != network;
                        _b.label = 2;
                    case 2:
                        if (_a)
                            throw new Error("Signing provider mismatched network");
                        this._signingProvider = signingProvider;
                        _b.label = 3;
                    case 3:
                        if (!(!fallbackWebsockethost && !signingProvider)) return [3 /*break*/, 5];
                        // No fallback provider so we want to wait for ethereum provider
                        // The reason we don't call detectEthereumProvider when a fallback provider is given is because we want fast loading
                        return [4 /*yield*/, (0, detect_provider_1.default)({ mustBeMetaMask: false, silent: true })];
                    case 4:
                        // No fallback provider so we want to wait for ethereum provider
                        // The reason we don't call detectEthereumProvider when a fallback provider is given is because we want fast loading
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        // Already initialzied, return.  Everything beyond this point can only execute once
                        if (this._intialized)
                            return [2 /*return*/];
                        this._intialized = true;
                        // Setup fallback host
                        if (fallbackWebsockethost !== undefined) {
                            try {
                                // Use fallback websocket host if provided
                                if (network) {
                                    //@ts-ignore
                                    this._fallbackProvider = new ethers_1.ethers.providers.WebSocketProvider(fallbackWebsockethost, parseInt(network));
                                }
                                else {
                                    this._fallbackProvider = new ethers_1.ethers.providers.WebSocketProvider(fallbackWebsockethost);
                                }
                            }
                            catch (_c) {
                                console.warn('Fallback Provider has invalid URL');
                            }
                        }
                        // Setup browser provider
                        return [4 /*yield*/, this._initializeBrowserProvider()
                            // Set provider
                        ];
                    case 6:
                        // Setup browser provider
                        _b.sent();
                        // Set provider
                        this._setProvider();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initialize the browser provider
     */
    _EthereumProvider._initializeBrowserProvider = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this._browserProviderInitialized) return [3 /*break*/, 3];
                        // Only configure once
                        this._browserProviderInitialized = true;
                        if (!window.ethereum) return [3 /*break*/, 2];
                        // Have browser provider, try to configure 
                        return [4 /*yield*/, this._setupBrowserProvider()];
                    case 1:
                        // Have browser provider, try to configure 
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        // No browser provider yet, configure once complete
                        (0, detect_provider_1.default)({ mustBeMetaMask: false, silent: true }).then(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!window.ethereum) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this._setupBrowserProvider()];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Setup a browser provider
     */
    _EthereumProvider._setupBrowserProvider = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // Have browser provider, try to configure 
                        // Add listeners
                        //@ts-ignore
                        window.ethereum.on("accountsChanged", function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this._handleEthereumAccountChange()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        //@ts-ignore
                        window.ethereum.on("chainChanged", function (chainId) {
                            _this._handleEthereumChainChange(parseInt(chainId));
                        });
                        //@ts-ignore
                        window.ethereum.on("disconnect", function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this._browserSelectedAddress = undefined;
                                this._browserSelectedENSName = undefined;
                                window.dispatchEvent(new Event(this.ADDRESS_CHANGED));
                                return [2 /*return*/];
                            });
                        }); });
                        if (!(window.ethereum && this._isBrowserProviderConnected() && (!this._browserProvider || (this._browserProvider.provider != window.ethereum)))) return [3 /*break*/, 3];
                        // Use the browser provider if it is connected
                        this._browserProvider = new ethers_1.ethers.providers.Web3Provider(window.ethereum, "any");
                        _a = this;
                        return [4 /*yield*/, this._browserProvider.getNetwork()];
                    case 1: return [4 /*yield*/, (_b.sent()).chainId];
                    case 2:
                        _a._browserChainId = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        if (window.ethereum && !this._isBrowserProviderConnected()) {
                            // Browser provider not connected, listen for connection
                            //@ts-ignore
                            window.ethereum.on("connect", function (connectInfo) {
                                _this._handleEthereumConnect(connectInfo);
                            });
                        }
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Helper to check if browser provider is connected
     */
    _EthereumProvider._isBrowserProviderConnected = function () {
        if (window.ethereum) {
            // Basic metamask handling
            if (window.ethereum.connected === true || (window.ethereum.isConnected && window.ethereum.isConnected()))
                return true;
            // Coinbase wrapped metamask handling
            if (window.ethereum.providers) {
                if (window.ethereum.providers.length) {
                    for (var i = 0; i < window.ethereum.providers.length; i++) {
                        var provider = window.ethereum.providers[i];
                        if (provider.connected === true || (provider.isConnected && provider.isConnected()))
                            return true;
                    }
                }
            }
            // Unknown window.ethereum handling (assume connected)
            if (window.ethereum.connected === undefined && window.ethereum.isConnected === undefined && window.ethereum.providers === undefined)
                return true;
        }
        return false;
    };
    // Set provider based on configured chain
    _EthereumProvider._setProvider = function () {
        var providerChanged = false;
        if (this._browserProvider && (!this._network || this._browserChainId == this._network)) {
            // We can use the browserProvider because it is on the correct network
            if (this._provider != this._browserProvider) {
                this._provider = this._browserProvider;
                providerChanged = true;
            }
        }
        else {
            // We cannot use the browser provider to sign as we are not on the right network
            if (this._signingProvider == this._browserProvider) {
                // If signing provider was the browser provider, set it to undefined as it is no longer connected
                this._signingProvider = undefined;
            }
            if (this._fallbackProvider || this._signingProvider) {
                // Use the fallback or signing provider if available
                var newProvider = this._fallbackProvider || this._signingProvider;
                if (this._provider != newProvider) {
                    this._provider = this._fallbackProvider;
                    providerChanged = true;
                }
            }
            else {
                // No provider available
                if (this._provider) {
                    providerChanged = true;
                    this._provider = undefined;
                }
                this._provider = undefined;
            }
        }
        // Dispatch event if provider changed
        if (providerChanged) {
            window.dispatchEvent(new Event(this.PROVIDER_CHANGED));
        }
    };
    /**
     * Handle ethereum connection
     */
    _EthereumProvider._handleEthereumConnect = function (connectInfo) {
        // Ethereum connection
        if (!this._browserProvider) {
            this._browserProvider = new ethers_1.ethers.providers.Web3Provider(window.ethereum, "any");
        }
        this._handleEthereumChainChange(parseInt(connectInfo.chainId));
    };
    /**
     * Handle ethereum chain changes
     */
    _EthereumProvider._handleEthereumChainChange = function (chainId) {
        // Chain change, you want to set up to use the right provider
        this._browserChainId = chainId;
        this._setProvider();
        window.dispatchEvent(new CustomEvent(this.CHAIN_CHANGED));
    };
    /**
     * Handle Ethereum account changes
     */
    _EthereumProvider._handleEthereumAccountChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newSelectedAddress, newSelectedENSName, accounts, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newSelectedAddress = undefined;
                        newSelectedENSName = undefined;
                        if (!(this._browserProvider && !this._userDisconnected)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this._browserProvider.listAccounts()];
                    case 1:
                        accounts = _a.sent();
                        if (!(!accounts.length && this._browserProvider.provider.isMetaMask)) return [3 /*break*/, 4];
                        // If this is MetaMask we need to enable it by making a request
                        // @ts-ignore
                        return [4 /*yield*/, this._browserProvider.provider.request({
                                method: 'eth_requestAccounts'
                            })];
                    case 2:
                        // If this is MetaMask we need to enable it by making a request
                        // @ts-ignore
                        _a.sent();
                        return [4 /*yield*/, this._browserProvider.listAccounts()];
                    case 3:
                        accounts = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (accounts.length) {
                            newSelectedAddress = accounts[0].toLowerCase();
                        }
                        _a.label = 5;
                    case 5:
                        if (!(newSelectedAddress != this._browserSelectedAddress)) return [3 /*break*/, 10];
                        this._browserSelectedENSName = undefined;
                        if (!(newSelectedAddress && this._provider)) return [3 /*break*/, 9];
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, this._provider.lookupAddress(newSelectedAddress)];
                    case 7:
                        newSelectedENSName = _a.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        error_1 = _a.sent();
                        return [3 /*break*/, 9];
                    case 9:
                        this._browserSelectedAddress = newSelectedAddress;
                        if (newSelectedENSName) {
                            this._browserSelectedENSName = newSelectedENSName;
                        }
                        window.dispatchEvent(new Event(this.ADDRESS_CHANGED));
                        _a.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Whether or not a browser provider has been set
     */
    _EthereumProvider.hasBrowserProvider = function () {
        if (this._browserProvider)
            return true;
        return false;
    };
    /**
     * Set a browser provider (e.g. walletconnect or any others)
     */
    _EthereumProvider.setSigningProvider = function (provider) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, newSigningProviderAddress, newSelectedENSName, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = !this._network;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, provider.getNetwork()];
                    case 1:
                        _a = (_b.sent()).chainId != this._network;
                        _b.label = 2;
                    case 2:
                        if (_a)
                            throw new Error("Signing provider mismatched network");
                        this._signingProvider = provider;
                        return [4 /*yield*/, provider.getSigner().getAddress()];
                    case 3:
                        newSigningProviderAddress = _b.sent();
                        if (!(newSigningProviderAddress != this._signingProviderAddress)) return [3 /*break*/, 8];
                        this._signingProviderENSName = undefined;
                        newSelectedENSName = undefined;
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, provider.lookupAddress(newSigningProviderAddress)];
                    case 5:
                        newSelectedENSName = _b.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        error_2 = _b.sent();
                        return [3 /*break*/, 7];
                    case 7:
                        this._signingProviderAddress = newSigningProviderAddress;
                        if (newSelectedENSName)
                            this._signingProviderENSName = newSelectedENSName;
                        window.dispatchEvent(new Event(this.ADDRESS_CHANGED));
                        _b.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Call to request login (for browser provider)
     */
    _EthereumProvider.connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Cannot connect if there is no active browser connection
                        if (!this._browserProvider || !this._isBrowserProviderConnected()) {
                            throw new WindowEthereumConnectionError();
                        }
                        if (!(!this._browserSelectedAddress && !this._connecting)) return [3 /*break*/, 4];
                        this._connecting = true;
                        this._userDisconnected = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._handleEthereumAccountChange()];
                    case 2:
                        _a.sent();
                        this._connecting = false; // we have fully connected
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        this._connecting = false;
                        throw error_3; // allow client to handle the error (usually rejection)
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Call to logout
     */
    _EthereumProvider.disconnect = function (strictAuth) {
        if (strictAuth === void 0) { strictAuth = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._browserSelectedAddress) {
                    (0, storage_1.deleteJWT)(this._browserSelectedAddress, strictAuth);
                    (0, storage_1.deleteOAuth)(this._browserSelectedAddress, strictAuth);
                }
                if (this._signingProviderAddress) {
                    (0, storage_1.deleteJWT)(this._signingProviderAddress, strictAuth);
                    (0, storage_1.deleteOAuth)(this._signingProviderAddress, strictAuth);
                }
                this._browserSelectedAddress = undefined;
                this._signingProviderAddress = undefined;
                this._signingProvider = undefined;
                this._userDisconnected = true;
                window.dispatchEvent(new Event(this.ADDRESS_CHANGED));
                return [2 /*return*/];
            });
        });
    };
    /**
     * @returns ethers provider instance
     */
    _EthereumProvider.provider = function (withSigner) {
        if (withSigner === void 0) { withSigner = false; }
        if (withSigner) {
            // Use signging provider if configured
            if (this._signingProvider)
                return this._signingProvider;
            // Use browser provider if connected
            if (this._browserSelectedAddress)
                return this._browserProvider;
            // No signing provider available
            return undefined;
        }
        return this._provider;
    };
    /**
     * @returns ethers Contract instance
     */
    _EthereumProvider.contractInstance = function (address, abi, withSigner) {
        if (withSigner === void 0) { withSigner = false; }
        var provider = this.provider(withSigner);
        if (provider === undefined)
            return undefined;
        var contract = new ethers_1.ethers.Contract(address, abi, this._provider);
        // Attach the signer if the provider is the browser provider
        if (withSigner) {
            contract = contract.connect(provider.getSigner());
        }
        return contract;
    };
    /**
     * @returns ethers ContractFactory instance
     */
    _EthereumProvider.contractFactoryInstance = function (abi, bytecode) {
        var provider = this.provider(true);
        if (provider === undefined)
            return undefined;
        return new ethers_1.ethers.ContractFactory(abi, bytecode, provider.getSigner());
    };
    /**
     * @returns selected address (undefined if not logged in)
     */
    _EthereumProvider.selectedAddress = function () {
        return this._signingProviderAddress || this._browserSelectedAddress;
    };
    /**
     * @returns selected ENS name (undefined if not logged in)
     */
    _EthereumProvider.selectedENSName = function () {
        return this._signingProviderENSName || this._browserSelectedENSName;
    };
    /**
     * @returns the configured network if any
     */
    _EthereumProvider.network = function () {
        return this._network;
    };
    /**
     * @returns the chain ID of the connected network
     */
    _EthereumProvider.chainId = function () {
        if (this._provider) {
            if (this._provider === this._browserProvider) {
                return this._browserChainId;
            }
            else {
                return this._provider._network.chainId;
            }
        }
        return undefined;
    };
    /**
     * Returns true if:
     *    You specified a signing provider
     *    There is no detected browser chain
     *    There is no network specified
     *    You are connected and your browser provider is using the same chain as the network
     *
     * Primarily use this after you connect.
     * Use this to check a user is on the right chain for WRITE functions.
     * Use this to show a warning if they're on the wrong chain AND connected
     *
     * @returns chainIsCorrect: bool
     */
    _EthereumProvider.chainIsCorrect = function () {
        return this._signingProvider !== undefined || this._browserChainId === undefined || this._network === undefined || this._browserChainId == this._network;
    };
    /**
     * Gets a token for the Implicit Grant flow for OAuth. Similar
     * to the other JWT method, this immediately gets a token
     * with which you can query our APIs.
     */
    _EthereumProvider.getOAuth = function (appName, redirectUri, clientId, strictAuth, delayAuth) {
        if (strictAuth === void 0) { strictAuth = true; }
        if (delayAuth === void 0) { delayAuth = false; }
        return __awaiter(this, void 0, void 0, function () {
            var account, oauth, url, challenge, provider, signature, res, resJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        account = this.selectedAddress();
                        if (!account)
                            throw new Error("Must connect before getting OAuth token");
                        oauth = (0, storage_1.getOAuth)(account, strictAuth);
                        if (!(!oauth && !delayAuth)) return [3 /*break*/, 4];
                        url = OAuthServer + "/token";
                        challenge = "Please sign this to allow " + appName + " access to view your NFTs.";
                        provider = this.provider(true);
                        if (!provider)
                            throw new Error("Not connected");
                        return [4 /*yield*/, provider.getSigner().signMessage(challenge)];
                    case 1:
                        signature = _a.sent();
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                body: JSON.stringify({
                                    signature: signature,
                                    appName: appName,
                                    redirectUri: redirectUri,
                                    clientId: clientId,
                                    grantType: 'token'
                                })
                            })];
                    case 2:
                        res = _a.sent();
                        if (res.status != 200)
                            throw new Error("Could not verify");
                        return [4 /*yield*/, res.json()];
                    case 3:
                        resJson = _a.sent();
                        if (!resJson.access_token)
                            throw new Error("Could not verify");
                        (0, storage_1.setOAuth)(account, strictAuth, resJson.access_token);
                        oauth = resJson.access_token;
                        _a.label = 4;
                    case 4: return [2 /*return*/, oauth];
                }
            });
        });
    };
    /**
     * Gets token for JWT Authentication. Retrieves the challenge and waits
     * for the user to sign it, then retrieves and returns the JWT from server.
     * It also stores the JWT as a  and dispatches an event on the
     * window to let the client know it's updated.
     */
    _EthereumProvider.getJWT = function (message, strictAuth, delayAuth) {
        if (message === void 0) { message = ""; }
        if (strictAuth === void 0) { strictAuth = true; }
        if (delayAuth === void 0) { delayAuth = false; }
        return __awaiter(this, void 0, void 0, function () {
            var account, jwt, url, queryParam, challengeRes, challenge, challengeHex, n, provider, signature, res, resJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        account = this.selectedAddress();
                        if (!account)
                            throw new Error("Must connect before getting JWT token");
                        jwt = (0, storage_1.getJWT)(account, strictAuth);
                        if (!(!jwt && !delayAuth)) return [3 /*break*/, 6];
                        url = JWTServer + "/auth-personal/" + account;
                        if (message.length) {
                            queryParam = "?message=" + encodeURIComponent(message);
                            url = "" + url + queryParam;
                        }
                        return [4 /*yield*/, fetch(url, {
                                method: 'GET',
                                mode: 'cors',
                                headers: {
                                    "Access-Control-Allow-Origin": "*"
                                }
                            })];
                    case 1:
                        challengeRes = _a.sent();
                        challenge = '';
                        return [4 /*yield*/, challengeRes.text()];
                    case 2:
                        challengeHex = _a.sent();
                        for (n = 0; n < challengeHex.length; n += 2) {
                            challenge += String.fromCharCode(parseInt(challengeHex.substr(n, 2), 16));
                        }
                        provider = this.provider(true);
                        if (!provider)
                            throw new Error("Not connected");
                        return [4 /*yield*/, provider.getSigner().signMessage(challenge)];
                    case 3:
                        signature = _a.sent();
                        return [4 /*yield*/, fetch(JWTServer + "/jwt-personal/" + account + "/" + signature, {
                                method: 'GET',
                                mode: 'cors',
                                headers: {
                                    "Access-Control-Allow-Origin": "*"
                                }
                            })];
                    case 4:
                        res = _a.sent();
                        if (res.status != 200)
                            throw new Error("Could not verify");
                        return [4 /*yield*/, res.json()];
                    case 5:
                        resJson = _a.sent();
                        if (!resJson.jwt)
                            throw new Error("Could not verify");
                        (0, storage_1.setJWT)(account, strictAuth, resJson.jwt);
                        jwt = resJson.jwt;
                        _a.label = 6;
                    case 6: return [2 /*return*/, jwt];
                }
            });
        });
    };
    _EthereumProvider.ADDRESS_CHANGED = "ethereum-address-changed";
    _EthereumProvider.PROVIDER_CHANGED = "ethereum-provider-changed";
    _EthereumProvider.CHAIN_CHANGED = "ethereum-provider-chain-changed";
    _EthereumProvider._provider = undefined;
    _EthereumProvider._intialized = false;
    _EthereumProvider._browserProviderInitialized = false;
    _EthereumProvider._browserProvider = undefined;
    _EthereumProvider._browserChainId = undefined;
    _EthereumProvider._browserSelectedAddress = undefined;
    _EthereumProvider._browserSelectedENSName = undefined;
    _EthereumProvider._signingProvider = undefined;
    _EthereumProvider._signingProviderAddress = undefined;
    _EthereumProvider._signingProviderENSName = undefined;
    _EthereumProvider._fallbackProvider = undefined;
    _EthereumProvider._connecting = false;
    // This variable is used to track user website disconnections and prevent auto reconnection when a user disconnects via the interface
    // then triggers a metamask disconnection (which would subsequently trigger a accountsChanged event)
    _EthereumProvider._userDisconnected = false;
    return _EthereumProvider;
}());
// Singleton instance
var EthereumProvider = _EthereumProviderSingleton();
exports.EthereumProvider = EthereumProvider;
// Instantiate EthereumProvider singleton
function _EthereumProviderSingleton() {
    if (!window.ManifoldEthereumProvider) {
        window.ManifoldEthereumProvider = _EthereumProvider;
    }
    return window.ManifoldEthereumProvider;
}
